import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import FirstLevel from 'views/Catalog/HealthContent/FirstLevel';
import Products from 'views/Catalog/HealthContent/SecondLevel/Products/Products';
import Images from 'views/Catalog/HealthContent/SecondLevel/Images';
import Facets from 'views/Catalog/HealthContent/SecondLevel/Facets';
import { RouteObject } from 'react-router-dom';
//  ========= users =========
const UsersList = Loadable(lazy(() => import('views/Security/Users')));
const UserProfile = Loadable(lazy(() => import('views/Security/UserProfile')));

// ========= products =========
const ProductList = Loadable(lazy(() => import('views/Catalog/Products')));
const EditProduct = Loadable(lazy(() => import('views/Catalog/Products/Edit')));
const CreateProduct = Loadable(lazy(() => import('views/Catalog/Products/Create')));

// ========= profiles =========
const ProfilesMainPage = Loadable(lazy(() => import('views/Security/Profiles')));
// ========= brands =========
const BrandsListPage = Loadable(lazy(() => import('views/Catalog/Brands/List')));

// ========= vendors =========
const VendorsListPage = Loadable(lazy(() => import('views/Catalog/Vendors/List')));
const VendorsAssociation = Loadable(lazy(() => import('views/Catalog/Vendors/VendorsAssociation')));
// ========= FACETS =========
const FacetsMainPage = Loadable(lazy(() => import('views/Catalog/Facets/Main')));

// ========= CATEGORIES =========
const CategoriesMainPage = Loadable(lazy(() => import('views/Catalog/Categories')));
const AssociatedFacet = Loadable(lazy(() => import('views/Catalog/Categories/AssociatedFacets/AssociatedFacet')));

// ========= MASSIVE LOAD =========
const MassiveLoadPage = Loadable(lazy(() => import('views/Catalog/MassiveLoad')));

// ========= MASSIVE APPROVALS =========
const MassiveApprovals = Loadable(lazy(() => import('views/Catalog/MassiveApprovals')));

// ========= CHANGE LOG =========
const ChangeLogPage = Loadable(lazy(() => import('views/Reports/ChangeLog')));

// ========= AI CONFIGURATION =========
const AiConfigurationPage = Loadable(lazy(() => import('views/pages/AIConfiguration')));

// TEST
const TestAdditionalFields = Loadable(lazy(() => import('views/Catalog/TestAdditionalFields')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes: RouteObject = {
    path: '/loolu/admin',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/loolu/admin',
            element: <FirstLevel />
        },
        {
            path: '/loolu/admin/products',
            element: <ProductList />
        },
        {
            path: '/loolu/admin/products/detail-product/:id',
            element: <EditProduct />
        },
        {
            path: '/loolu/admin/products/create-product',
            element: <CreateProduct />
        },
        // ========= users =========
        {
            path: '/loolu/admin/users',
            element: <UsersList />
        },
        {
            path: '/loolu/admin/users/:userId/edit',
            element: <UserProfile />
        },
        // ========= profiles =========
        {
            path: '/loolu/admin/profiles',
            element: <ProfilesMainPage />
        },
        // ========= brands =========
        {
            path: '/loolu/admin/brands',
            element: <BrandsListPage />
        },
        // ========= vendors =========
        {
            path: '/loolu/admin/vendors',
            element: <VendorsListPage />
        },
        {
            path: '/loolu/admin/vendors/associated/:idMerchant/:nameVendor/:idProvider',
            element: <VendorsAssociation />
        },
        // ========= FACETS =========
        {
            path: '/loolu/admin/facets',
            element: <FacetsMainPage />
        },
        // ========= CATEGORIES =========
        {
            path: '/loolu/admin/categories',
            element: <CategoriesMainPage />
        },
        {
            path: '/loolu/admin/categories/facets-assosiation/:idMerchant/:categoryName/:idCategory',
            element: <AssociatedFacet />
        },
        //  ======== HEALTH CONTENT =========
        {
            path: '/loolu/admin/health-content/overall-score',
            element: <FirstLevel />
        },
        {
            path: '/loolu/admin/health-content/overall-score/products',
            element: <Products />
        },
        {
            path: '/loolu/admin/health-content/overall-score/images',
            element: <Images />
        },
        {
            path: '/loolu/admin/health-content/overall-score/facets',
            element: <Facets />
        },
        // ========= MASSIVE  LOAD =========
        {
            path: '/loolu/admin/massive_load',
            element: <MassiveLoadPage />
        },
        // ========= PENDING APPROVALS =========
        {
            path: '/loolu/admin/products/pending_approvals',
            element: <MassiveApprovals />
        },
        // ========= REPORTS - CHANGE LOG =========
        {
            path: '/loolu/admin/change_log',
            element: <ChangeLogPage />
        },
        // ========= AI CONFIGURATION PAGE =========
        {
            path: '/loolu/admin/products/aiconfig',
            element: <AiConfigurationPage />
        },
        // TEST ADDITIONAL FIELDS UI
        {
            path: '/loolu/admin/test-page',
            element: <TestAdditionalFields />
        }
    ]
};

export default MainRoutes;
